import ApplicationController from "../../application_component_controller";

import { useOutlets } from "hb/insights/use_outlets";
import { useListen } from "hb/insights/use_listen";
import { duplicate } from "hb/insights/utils";

export default class extends ApplicationController {
  static values = {
    querySessionId: String,
    widgetId: String,
  };

  connect() {
    useListen(this);
    useOutlets(this, { components: ["queryState"] });

    this.listenWindow("updateQueryState", this.queryStateUpdated);
  }

  queryStateUpdated({ query }) {
    this.element.setAttribute("data-query", query);
  }

  update() {
    this.emitWindow("queryVisConfig:update", {
      querySessionId: this.querySessionIdValue,
      config: duplicate(this.outletComponent("queryState").queryVisState),
    });

    this.emitWindow("dashboard:finishEditingWidget", {
      widgetId: this.widgetIdValue,
    });
    this.emitWindow("dashboard:closePanels");
  }

  cancel() {
    this.emitWindow("dashboard:finishEditingWidget", {
      widgetId: this.widgetIdValue,
    });
    this.emitWindow("dashboard:closePanels");
  }
}
